<template>
  <div class="contact">
    <div class="page-back">
      <i class="el-icon-arrow-left" @click="goBack()"
      ><span class="desc">{{ $t('mark_back') }}</span></i
      >
    </div>
    <div class="feedback">
      <p class="title">{{ $t('feedback') }}</p>
      <p class="feedback-title bold grey">
        <span>{{ $t('please_enter_content') }} </span>
        <svg-icon type="require" class="icon-require icon-5"></svg-icon>
      </p>
      <el-input
        class="feedback-content m-b-10"
        type="textarea"
        v-model="content"
        :autosize="{ minRows: 6, maxRows: 20 }"
      >
      </el-input>
      <p class="feedback-title bold grey" v-if="!isLogin">
        <span>{{ $t('email_address') }} </span>
        <svg-icon type="require" class="icon-require icon-5"></svg-icon>
      </p>
      <el-input
        class="feedback-content m-b-10"
        type="text"
        v-model="email"
        v-if="!isLogin"
      >
      </el-input>
      <p class="feedback-title bold grey">
        <span>{{ $t('upload_picture', { maxFiles: maxFiles }) }}</span>
        <!-- <svg-icon type="require" class="icon-require icon-5"></svg-icon> -->
      </p>
      <div class="feedback-file m-t-12">
        <div class="file-card file-thumbnail m-r-12 m-b-12" v-for="file in files" :key="file.url">
          <span class="font-12 p-6" v-if="file.file.type == 'application/pdf'">{{
              file.file.name
            }}</span>
          <img v-else :src="file.url" :alt="file.file.name" class="image" />
          <i class="clickable el-icon-delete" @click="clickRemoveFile(file)"></i>
        </div>
        <el-upload
          class="file-add m-r-12"
          list-type="picture-card"
          accept="image/jpeg,image/png,application/pdf"
          action="#"
          :multiple="true"
          :limit="maxFiles"
          :show-file-list="false"
          :before-upload="handleBeforeUpload"
          :http-request="handleUpload"
          :file-list="files"
          :on-exceed="handleExceed"
        >
          <i slot="default" class="el-icon-plus"></i>
        </el-upload>
      </div>

      <div class="feedback-btn">
        <mui-button
          class="submit-button"
          type="yellow"
          size="large"
          :disabled="disabledSubmit"
          :loading="loading"
          :loadingText="$t('loading')"
          @click="clickSubmit"
        >
          {{ $t('submit') }}
        </mui-button>
      </div>
    </div>
  </div>
</template>

<script>
import {uploadFiles, uploadFilesUnLogin, saveFeedback, saveFeedbackUnLogin} from '@/serves/api/feedback'
import  CryptoJS from 'crypto-js';
import {checkEmail} from "@/utils/validation";

export default {
  name: 'Feedback',
  data() {
    return {
      loading: false,
      content: '',
      email: "",
      files: [],
      maxFiles: 9,
    }
  },
  computed: {
    limit() {
      return this.maxFiles - this.files.length
    },
    disabledSubmit() {
      if (this.isLogin) {
        return this.content.trim().length <= 0
      } else {
        return this.content.trim().length <= 0 || this.email.trim().length <= 0
      }
    },
    isLogin() {
      return this.$store.state.user.login
    },
  },
  methods: {
    handleBeforeUpload(file) {
      // 文件类型、文件大小
      const isValidType = ['image/jpeg', 'image/png', 'image/jpg'].includes(file.type)
      const isLt10M = file.size / 1024 / 1024 <= 10

      if (!isValidType || !isLt10M) {
        this.$message.error(file.name + this.$t('file_error'))
        return false
      }

      return true
    },
    handleUpload(params) {
      const formData = new FormData()
      formData.append('files', params.file, params.file.name)
      if (this.isLogin) {
        uploadFiles(formData).then((response) => {
          this.files.push({
            file: params.file,
            url: response.data[0],
          })
        })
      } else {
        uploadFilesUnLogin(formData).then((response) => {
          this.files.push({
            file: params.file,
            url: response.data[0],
          })
        })
      }

    },
    handleExceed() {
      this.$message.error(this.$t('file_num_limit', { maxFiles: this.maxFiles }))
    },
    clickRemoveFile(file) {
      const findIndex = this.files.findIndex((f) => f.url === file.url)
      if (findIndex >= 0) {
        this.files.splice(findIndex, 1)
      }
    },
    clickSubmit() {
      this.loading = true

      if (this.isLogin) {
        saveFeedback({
          content: this.content,
          images: this.files?.map((file) => file.url),
          device_version: `mock-web-${process.env.VUE_APP_VERSION}`,
        })
          .then(() => {
            this.$message({ type: 'success', message: this.$t('feedback_success') })
            this.$router.push({ path: 'home / index' })
          })
          .catch((errmsg) => {
            this.$message({ type: 'error', message: errmsg || this.$t('feedback_error') })
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        if (!checkEmail(this.email)) {
          this.loading = false
          this.$message({ type: 'error', message: this.$t('invalid_email_address') })
          return false
        }
        const timestamp = Math.floor(Date.now() / 1000); // 获取当前时间戳(秒)

        // 构造请求参数
        const data = {
          content: this.content,
          email: this.email,
          device_version: `mock-web-${process.env.VUE_APP_VERSION}`,
          timestamp: timestamp,
        };

        // 计算签名
        const secretKey = 'E1E085A1B0AE9653'; // 服务器提供的密钥
        const signature = this.generateSignature(secretKey, data);

        saveFeedbackUnLogin({
          content: this.content,
          email: this.email,
          images: this.files?.map((file) => file.url),
          device_version: `mock-web-${process.env.VUE_APP_VERSION}`,
          timestamp: timestamp,
          signature: signature,
        })
          .then(() => {
            this.$message({ type: 'success', message: this.$t('feedback_success') })
            this.$router.push({ path: 'home / index' })
          })
          .catch((errmsg) => {
            this.$message({ type: 'error', message: errmsg || this.$t('feedback_error') })
          })
          .finally(() => {
            this.loading = false
          })
      }


    },
    goBack() {
      this.$router.back()
    },
    generateSignature(secretKey, data) {
      // 排序参数
      const sortedData = Object.keys(data).sort().map(key => `${key}=${data[key]}`).join('&');

      // 使用 HMAC-SHA256 计算签名
      const hmac = CryptoJS.HmacSHA256(sortedData, secretKey).toString(CryptoJS.enc.Hex);

      return hmac;
    }
  },
}
</script>

<style lang="scss" scoped>
.page-back {
  margin-bottom: 14px;

  cursor: pointer;
  .desc {
    color: #474b64;
    font-family: 'Inter';
    font-weight: 500;
    font-size: 12px;
  }

  @media screen and (max-width: 768px) {
    width: 95%;
    margin: 0 auto 14px;
  }
}
.feedback {
  width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #efeff1;
  border-radius: 12px;
  padding: 38px 60px 30px;
  .title {
    color: #2c2f46;
    font-family: Inter;
    font-size: 32px;
    font-weight: 700;
    text-align: center;
  }
  .feedback-title {
    position: relative;
    margin: 14px 0;
    span {
      color: #000;
      font-family: Inter;
      font-size: 14px;
      font-weight: 700;
    }
    .icon-require {
      position: absolute;
      top: 3px;
      margin-left: 3px;
    }
  }

  .feedback-content {
    ::v-deep .el-textarea__inner {
      height: 167px !important;
      border-radius: 12px;
      background: #fafafb;
      border: none !important;
      outline: none !important;
      border: none;
      padding: 18px 20px;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      resize: none;
    }
  }

  .feedback-file {
    display: flex;

    .file-card {
      position: relative;
      width: 130px;
      height: 130px;
      background: #ffffff;
      border: 1px solid #e7e7ed;
      border-radius: 4px;

      display: flex;
      justify-content: center;
      align-items: center;

      .el-icon-delete {
        position: absolute;
        width: 20px;
        height: 20px;
        top: -8px;
        right: -8px;
        background: red;
        color: #fff;
        border-radius: 51%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
      }
      .image {
        max-height: 90px;
      }
    }
    .file-add {
      ::v-deep .el-upload__input {
        display: none !important;
      }
      ::v-deep .el-upload--picture-card {
        width: 130px;
        height: 130px;
        line-height: 145px;
        background-color: #fff;
        border-radius: 12px;
        border: 1px solid #e7e7ed;
        &:hover {
          background-color: #fafafb;
        }
        .el-icon-plus {
          color: #b5b5be;
          font-size: 40px;
        }
      }
    }
  }

  .feedback-btn {
    display: flex;
    justify-content: center;
    .submit-button {
      margin-top: 96px;
      display: flex;
      width: 254px;
      padding: 10px 24px;
      flex-direction: column;
      align-items: center;
      border-radius: 4px;
    }
  }

  @media screen and (max-width: 768px) {
    width: 95%;
    padding: 20px;
    .title {
      font-size: 24px;
    }

    .feedback-title {
      margin: 10px 0;
      span {
        font-size: 12px;
      }
    }
    .feedback-content {
      ::v-deep .el-textarea__inner {
        height: 100px !important;
        font-size: 12px;
      }
    }
    .feedback-btn {
      .submit-button {
        width: 100%;
        padding: 10px 0;
        font-size: 14px;
      }
    }
  }
}
</style>
